import React, { useEffect, useRef, useState } from 'react';

const WatermarkedImage = ({ imageUrl, altText, isMobile, watermarkText = "MyFreeScoreNow" }) => {
    const canvasRef = useRef(null);
    const [finalImage, setFinalImage] = useState('');
    const [originalSize, setOriginalSize] = useState({ width: 0, height: 0 });
  useEffect(() => {
    const img = new Image();
    img.crossOrigin = 'anonymous'; // Allow CORS
    img.src = imageUrl;

    img.onload = () => {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');

      canvas.width = img.width;
      canvas.height = img.height;

      setOriginalSize({ width: img.width, height: img.height });

      ctx.drawImage(img, 0, 0);

      // Watermark
      ctx.font = `${img.width / 15}px Arial`; // Scale font with image width
      ctx.fillStyle = 'rgba(7, 42, 238, 0.66)';
      ctx.textAlign = 'center';
      ctx.fillText(watermarkText, canvas.width / 2, canvas.height / 2);

      setFinalImage(canvas.toDataURL());
    };
  }, [imageUrl, watermarkText]);

  return (
    <>
      <canvas ref={canvasRef} style={{ display: 'none' }} />
      {finalImage && (
        <img
          src={finalImage}
          alt={altText}
          style={{
            width: '250px',
            height: 'auto',
            borderRadius: 0,
            objectFit: 'cover',
          }}
          onContextMenu={(e) => e.preventDefault()} // Disable right click
        />
      )}
    </>
  );
};

export default WatermarkedImage;
